import React from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import Box from "@mui/material/Box";
import { useLocation, Link as RouterLink } from "react-router-dom";
import { useSelector } from "react-redux";
import FacebookIcon from "@mui/icons-material/Facebook";
import LinkedInIcon from "@mui/icons-material/LinkedIn";

function Copyright() {
  return (
    <Typography sx={{ fontSize: { xs: 16, md: 19 }, color: "#FFF" }}>
      {"Copyright © "} {new Date().getFullYear()}{" "}
      <Link
        color="inherit"
        href={"https://vucaware.com/"}
        sx={{ cursor: "pointer" }}
        target="_blank"
      >
        Vucaware
      </Link>
    </Typography>
  );
}

export default function FooterComponent() {
  const location = useLocation();
  // Read footerLinks from Redux
  const footerLinks = useSelector(
    (state) => state?.appConfigurationReducer?.footerLinks || []
  );

  // Filter out widget items and map to render format
  const filteredFooterLinks = footerLinks
    .filter((item) => item?.key !== "widget" && item?.key !== "Widget")
    .map((item) => ({
      key: item.key,
      label: item.label,
      link: item.link,
      isInternal: item.link && item.link.startsWith("/"),
    }));

  const social = [
    {
      title: "Facebook",
      icon: <FacebookIcon sx={{ fontSize: 30, color: "#FFF" }} />,
      link: "https://www.facebook.com/TrueSelfy",
    },
    {
      title: "LinkedIn",
      icon: <LinkedInIcon sx={{ fontSize: 30, color: "#FFF" }} />,
      link: "https://www.linkedin.com/showcase/trueselfy/",
    },
  ];

  return (
    <Box sx={{ py: 3 }}>
      <Grid
        container
        spacing={{ xs: 2, md: 0 }}
        justifyContent="space-between"
        alignItems="center"
        sx={{
          px: { xs: 2, sm: 5, md: 5, lg: 10, xl: 15 },
        }}
      >
        {/* Left Section: Navigational Links */}
        <Grid item xs={12} md={6}>
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: 2,
              justifyContent: { xs: "center", md: "flex-start" },
              alignItems: "center",
            }}
          >
            {filteredFooterLinks.map((footer, index) => {
              // Hide internal link if current route matches
              if (footer.isInternal && location.pathname === footer.link) {
                return null;
              }

              // Render internal links with React Router Link
              if (footer.isInternal) {
                return (
                  <Link
                    key={footer.key || index}
                    component={RouterLink}
                    to={footer.link}
                    sx={{
                      color: "#FFF",
                      fontSize: { xs: 16, md: 19 },
                      textDecoration: "underline",
                      cursor: "pointer",
                      "&:hover": {
                        color: "#26801E",
                      },
                    }}
                  >
                    {footer.label}
                  </Link>
                );
              }

              // Render external links with <a> tag
              return (
                <Link
                  key={footer.key || index}
                  href={footer.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{
                    color: "#FFF",
                    fontSize: { xs: 16, md: 19 },
                    textDecoration: "underline",
                    "&:hover": {
                      color: "#26801E",
                    },
                  }}
                >
                  {footer.label}
                </Link>
              );
            })}
          </Box>
        </Grid>

        {/* Right Section: Copyright and Social Media */}
        <Grid item xs={12} md={6}>
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              gap: 2,
              justifyContent: { xs: "center", md: "flex-end" },
              alignItems: "center",
            }}
          >
            <Copyright />
            <Box
              sx={{
                display: "flex",
                gap: 2,
              }}
            >
              {social.map((item, index) => (
                <Link
                  key={index}
                  href={item?.link}
                  target="_blank"
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    color: "#FFF",
                    "&:hover": {
                      color: "#26801E",
                    },
                  }}
                >
                  {item.icon}
                </Link>
              ))}
            </Box>
          </Box>
        </Grid>
      </Grid>
      <Box sx={{ display: "none" }}>
        {/* Hidden SEO tags for roles */}
        <p>
          Software Engineer, Technical Architect, Data Engineer, Project
          Manager, Product Manager, DevOps Engineer, Security Specialist,
          Cybersecurity Analyst, Backend Developer, Frontend Developer, Full
          Stack Developer, QA Engineer, Test Automation Engineer, Cloud
          Engineer, Site Reliability Engineer, Infrastructure Engineer, UI/UX
          Designer, Scrum Master, IT Consultant, AI Engineer, Machine Learning
          Engineer, Database Administrator, System Analyst, Business Analyst,
          Network Engineer, IT Support Engineer
        </p>
      </Box>
    </Box>
  );
}
